<template>
    <el-container class="healthy page-x" direction="vertical">
        <div class="search-x">
            <div class="search-item">
                <span class="label">权益人信息</span>
                <el-input class="input-box" clearable placeholder="权益人用户ID、姓名" v-model.trim="searchBox.rightsUserInfo">
                </el-input>
            </div>
            <div class="search-item">
                <span class="label">状态</span>
                <el-select v-model="searchBox.state" clearable>
                    <el-option v-for="item in orderState" :value="item.value" :key="item.value" :label="item.label">
                    </el-option>
                </el-select>
            </div>
            <div class="search-item">
                <span class="label">供应商</span>
                <select-all v-model="searchBox.providerIds"
                    :data="supplierList"
                    :option="{label: 'providerName', value: 'id'}">
                </select-all>
            </div>
            <div class="search-item">
                <span class="label">订单号</span>
                <el-input class="input-box" clearable placeholder="订单号" v-model.trim="searchBox.orderNo"></el-input>
            </div>
            <div class="search-item">
                <span class="label">预约用户信息</span>
                <el-input class="input-box input-box-big" clearable placeholder="预约用户姓名、手机号、证件号"
                    v-model.trim="searchBox.treatmentUserInfo"></el-input>
            </div>
            <div class="search-item">
                <span class="label">服务单号</span>
                <el-input class="input-box" clearable placeholder="服务单号" v-model.trim="searchBox.serviceNo"></el-input>
            </div>
            <div class="search-item">
                <span class="label">服务项目名称</span>
                <select-all v-model="searchBox.itemIds"
                    placeholder="服务项目名称"
                    :data="serviceList"
                    :option="{label: 'itemName', value: 'id'}">
                </select-all>
            </div>
            <!-- <div class="search-item">
                <span class="label">服务单号</span>
                <el-input
                    class="input-box"
                    clearable
                    placeholder="服务单号"
                    v-model.trim="searchBox.userInfo"
                ></el-input>
            </div> -->
            <div class="search-item">
                <span class="label">订单生成时间</span>
                <el-date-picker v-model="timeCache.createTime" @change="
                    (e) =>
                        toChangeTime(
                            e,
                            'createBeginTime',
                            'createEndTime'
                        )
                " type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    :picker-options="{
                        disabledDate(time) {
                            return time.getTime() > Date.now();
                        },
                    }">
                </el-date-picker>
            </div>
            <div class="search-item">
                <span class="label">预约体检时间</span>
                <el-date-picker v-model="timeCache.treatmentTime" @change="
                    (e) => toChangeTime(e, 'treatmentBeginTime', 'treatmentEndTime')
                " type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </div>
            <div class="search-item">
                <span class="label">已出报告时间</span>
                <el-date-picker v-model="timeCache.completeTime"
                    @change="(e) => toChangeTime(e, 'completeBeginTime', 'completeEndTime')" type="daterange"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </div>
            <el-button v-auth="'sa_order_page'" type="primary" @click="toSearch">查询</el-button>
            <el-button v-auth="'sa_order_page'" type="primary" @click="() => ($root.showPage = false)">重置</el-button>
            <el-button v-auth="'sa_order_export'" type="warning" @click="toExport">导出数据</el-button>
        </div>
        <div class="cont-x">
            <div class="table-x" ref="tableBox">
                <el-table v-loading="loading" :data="tableData" :height="tableHeight" border class="mb20">
                    <el-table-column prop="orderNo" align="center" label="序号">
                        <template slot-scope="scope">
                            {{
                                    (searchBox.pageNo - 1) * searchBox.pageSize +
                                    scope.$index +
                                    1
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderNo" align="center" label="订单号" width="200">
                    </el-table-column>
                    <el-table-column prop="serviceNo" align="center" width="160" label="服务单号"></el-table-column>
                    <el-table-column prop="productName" align="center" width="160" label="服务项目名称"></el-table-column>
                    <el-table-column prop="name" align="center" width="160" label="预约用户姓名"></el-table-column>
                    <el-table-column prop="mobile" align="center" width="160" label="手机号"></el-table-column>
                    <el-table-column prop="cardType" align="center" label="证件类型" width="160">
                        <template slot-scope="scoped">
                            <span>{{
                                    cardType[scoped.row.cardType] || scoped.row.cardType
                            }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cardNo" align="center" width="160" label="证件号"></el-table-column>
                    <el-table-column prop="printNo" align="center" width="160" label="性别">
                        <template slot-scope="scoped">
                            <span v-if="scoped.row.gender">{{
                                    scoped.row.gender == '1' ? '男' : '女'
                            }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="age" align="center" width="160" label="年龄"></el-table-column>
                    <el-table-column prop="marital" align="center" width="160" label="婚姻状况">
                        <template slot-scope="scoped">
                            <span v-if="scoped.row.marital == 0">不限</span>
                            <span v-if="scoped.row.marital == 1">已婚</span>
                            <span v-if="scoped.row.marital == 2">未婚</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="rightsUserId" align="center" width="160" label="权益人用户ID">
                        <template slot-scope="scoped">
                            <span>{{ scoped.row.rightsUserId ? scoped.row.rightsUserId : "--" }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="rightsUserName" align="center" width="160" label="权益人姓名"></el-table-column>
                    <el-table-column prop="relation" align="center" width="160" label="与权益人关系">
                        <template slot-scope="scoped">
                            <span>{{
                                    relation[scoped.row.relation] || scoped.row.relation
                            }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="state" align="center" label="状态" width="160">
                        <template slot-scope="scoped">
                            <span>{{
                                    scoped.row.state | filterValue(orderState)
                            }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="updateStateTime" align="center" width="160" label="状态更新时间"></el-table-column>
                    <el-table-column prop="appointExamTime" align="center" width="160" label="预约体检时间"></el-table-column>
                    <el-table-column prop="appointOrg" align="center" width="160" label="预约机构"></el-table-column>
                    <el-table-column prop="providerName" align="center" width="160" label="供应商"></el-table-column>
                    <el-table-column prop="printNo" align="center" width="160" label="操作">
                        <template slot-scope="scope">
                            <el-button size="middle" class="mb10" type="text" @click="showDetail(scope.row.id)">状态轨迹
                            </el-button>
                            <el-button v-if="scope.row.reportAuditState == 3" size="middle" class="mb10" type="text" @click="toDetail(scope.row.bookingId || scope.row.id)">查看</el-button>
                            <el-button v-if="scope.row.state == 3" size="middle" class="mb10" type="text"
                                @click="downPDF(scope.row.reportUrl)">下载</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="pagenation-x">
            <div class="pagination mb20">
                <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :page-sizes="[10,50,100]" :current-page="searchBox.pageNo"
                    :page-size.sync="searchBox.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"
                    background>
                </el-pagination>
            </div>
        </div>
        <drag-dialog title="服务轨迹" v-model="dialogVisible">
            <div class="dialog-list">
                <div class="dialog-list-box">
                    <el-table :data="historicalTrack" border style="width: 100%">
                        <el-table-column prop="changeTime" label="时间"></el-table-column>
                        <el-table-column prop="targetStatus" label="状态"></el-table-column>
                        <el-table-column prop="operation" label="操作"></el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                    </el-table>
                </div>
            </div>
        </drag-dialog>
    </el-container>
</template>

<script>
import dragDialog from "@/components/health/dragDialog.vue";
import { dateFormat } from "@/assets/js/until.js";
import { cardType, relation, operation } from "@/assets/js/options";
import SelectAll from "@/components/SelectAll";
export default {
    name: "healthy",
    components: {
        dragDialog,
        SelectAll
    },
    data() {
        return {
            cardType, // 证件类型list
            tableHeight: 0, // 表格高度
            orderState: [
                {
                    value: 0,
                    label: '已预约',
                },
                {
                    value: 1,
                    label: '已取消',
                },
                {
                    value: 2,
                    label: '已到检',
                },
                {
                    value: 3,
                    label: '已出报告',
                },
                {
                    value: 4,
                    label: '待预约',
                }
            ], // 订单状态list （与公共状态不同步）
            relation, // 与权益人关系list
            operation, // 操作list
            // table表格
            loading: false,
            tableData: [], // table数据
            total: 0,
            // 查询条件
            timeCache: {}, // 时间缓存
            supplierList: [], // 供应商列表
            serviceList: [], // 服务项目名称列表
            statusArr: [],
            searchBox: {
                pageSize: 10,
                pageNo: 1,
            }, // 搜索条件
            // 弹窗
            dialogVisible: false, // 弹窗visible
            historicalTrack: [], // 订单状态历史轨迹
        };
    },
    mounted() {
        this.getServiceList();
        this.getSupplierList();
        this.$nextTick(()=>{
            this.listenWindow()
            this.getData()
        })
    },
    created() {
        // 面包导航
        this.$root.breadList = [
            { name: "服务订单", link: "" },
            { name: "健康体检订单", link: "" },
        ];
    },
    methods: {
        //窗口改变，重新取得高度
        listenWindow() {
            this.tableHeight = this.$refs.tableBox.offsetHeight;
            window.addEventListener('resize', ()=>{
                clearTimeout(this.resizeFlag)
                                    this.resizeFlag = setTimeout(() => {
                    try {
                        this.tableHeight = this.$refs.tableBox.offsetHeight;
                    } catch (error) {}
                }, 300);
            })
        },
        /**
         * 获取服务项目列表
         */
        async getServiceList() {
            let res = await this.axios.get(this.getApiUrl("medicalOrderItemList"), {
                params: {},
            });
            this.serviceList = res?.data || [];
        },
        /**
         * 获取供应商列表
         */
        async getSupplierList() {
            let res = await this.axios.get(this.getApiUrl("medicalOrderProviderList"), {
                params: {},
            });
            this.supplierList = res?.data|| [];
        },
        /**
         * 下载pdf
         */
        downPDF(url) {
            console.log(url)
            let cache = url.split('/')
            let name = cache[cache.length - 1].split('.')
            this.$root.exportFile(url, {}, name[0], '.' + name[1])
        },
        /**
         * 显示弹窗
         */
        showDetail(id) {
            // 清空状态
            this.historicalTrack = []
            this.dialogVisible = true;
            // 请求
            this.getHistoricalTrack(id)
        },
        /**
         * 跳转详情
         */
        toDetail(id) {
            this.$router.push({
                name: 'ServiceOrderHealthyDetail',
                query: {
                    id,
                }
            })
        },
        /**
         * 订单状态历史轨迹
         */
        async getHistoricalTrack(id) {
            let res = await this.axios.get(this.getApiUrl("medicalOrderHistoricalTrack"), {
                params: { orderId: id },
            });
            this.historicalTrack = res?.data || [];
            console.log(this.historicalTrack)
        },
        /**
         * 搜索按钮
         */
        toSearch() {
            this.searchBox.pageNo = 1
            this.getData();
        },
        /**
         * 导出数据
         */
        async toExport() {
            var params = { ...this.searchBox }
            Object.keys(params).forEach((key) => {
                if (Object.prototype.toString.call(params[key]) === "[object Array]") {
                    params[key] = params[key].length == 1 ? params[key][0] : params[key].join(",");
                }
                if (params[key] === '' || params[key] === undefined || params[key] === null) delete params[key] // 请求时删除冗余字段
            })
            delete params.pageNo;
            delete params.pageSize;
            let urlPath = this.getApiUrl("medicalOrderExport")
            this.$root.exportFile(urlPath, params, "健康体检导出")
        },
        /**
         * 获取数据
         */
        async getData() {
            var params = { ...this.searchBox }
            Object.keys(params).forEach((key) => {
                if (Object.prototype.toString.call(params[key]) === "[object Array]") {
                    params[key] = params[key].length == 1 ? params[key][0] : params[key].join(",");
                }
                if (params[key] === '' || params[key] === undefined || params[key] === null) delete params[key] // 请求时删除冗余字段
            })
            const res = await this.axios
                .get(this.getApiUrl('medicalOrderPage'), {
                    params
                })
            console.log("获取数据", res);
            if (res.data) {
                this.tableData = res.data.data;
                this.total = res.data.total
            }
        },
        /**
         * 换页
         */
        handleCurrentChange(val) {
            this.searchBox.pageNo = val;
            this.getData();
        },
        handleSizeChange( val ){
            this.searchBox.pageNo = 1;
            this.searchBox.pageSize = val;
            this.getData();
        },
        /**
         * 时间回调函数
         */
        toChangeTime(val, startName, endName) {
            console.log(val);
            if (val && val.length) {
                this.searchBox[startName] = dateFormat(val[0]);
                this.searchBox[endName] = dateFormat(val[1]);
            } else {
                this.searchBox[startName] = "";
                this.searchBox[endName] = "";
            }
        },
    },
    filters: {
        filterValue(text, data) {
            return (
                data.find((item) => {
                    if (text === item.value) {
                        return item;
                    }
                })?.label || ""
            );
        },
    }
};
</script>

<style lang="scss" scoped>
.cont-x {
  flex: 1;
  flex-shrink: 0;
  .table-x {
    height: 100%;
  }
}
  .input-box-big {
    width: 250px;
  }
</style>